const Constants = {
    toolTipcard:
        'Find your 19-digit number on the back of the card. If using an e-Gift card, find your 19-digit e-Gift card number and ID number at the top of your email, just under the amount.',
    toolTipcardV2:
        'Find your 16 or 19-digit number on the back of the card. If using an e-Gift card, find your 16 or 19-digit e-Gift card number and ID number at the top of your email, just under the amount.',
    toolTipPin: 'Scratch off your 4-digit PIN number, which is found on the back of your card.',
    toolTipPinV2:
        'Scratch off your 4 or 8-digit PIN number, which is found on the back of your card.',
    labelPin: 'PIN',
    labelGC: 'Gift Card Number',
    INVISIBLE: 'invisible',
    VISIBLE: 'visible',
    GC_CAPTCHA: 'gc_captcha',
    BLUR: 'blur',
    CHECK_ANOTHER_CARD: 'Check Another Card',
    CHECK_BALANCE: 'Check Balance',
    CARD_ERROR: 'Enter a valid 19-digit number',
    CARD_ERROR_V2: 'Enter a valid 16-digit or 19-digit gift card number',
    PIN_ERROR: 'Enter a valid 4-digit number',
    PIN_ERROR_V2: 'Enter a valid 4-digit or 8-digit PIN',
    BLANK: '',
};

export default Constants;
